import { createClosingGame, awardScoreToOpenOpponents } from '../shared/closing-game.js';

// Same targets and marks/closing rules as Cricket. The only differences:
// once you've closed a number, further hits on it add points to every
// opponent who hasn't closed it yet (instead of to yourself), and the
// player with the LOWEST score when the game ends wins.
export default createClosingGame({
    id: 'cutthroat',
    name: 'Cutthroat',
    description: "Cricket's rules, flipped: hitting a number you've already closed adds points to every opponent who hasn't closed it yet, not to yourself. Lowest score wins instead of highest.",
    getTargets: () => [20, 19, 18, 17, 16, 15, 'bull'],
    awardScore: awardScoreToOpenOpponents,
    lowestWins: true
});
